//
// # Entity Kind
//
// Enumerated type-tag for all sorts of things throughout schematics and symbols.
// Serves as the discriminant in the `entityKind` field of many type unions.
// It is fairly important that no two such types have the same `entityKind`.
//
export enum EntityKind {
  Instance = "Instance",
  SymbolPin = "SymbolPin",
  SymbolPinShape = "SymbolPinShape",
  SymbolPinLabel = "SymbolPinLabel",
  SchPin = "SchPin",
  TextLabel = "TextLabel",
  ExprLabel = "ExprLabel",
  EvalLabel = "EvalLabel",
  WireSegment = "WireSegment",
  WireLabel = "WireLabel",
  Dot = "Dot",
  Text = "Text",
  Arc = "Arc",
  ArcCorner = "ArcCorner",
  Ellipse = "Ellipse",
  EllipseBody = "EllipseBody",
  EllipseCorner = "EllipseCorner",
  Rect = "Rect",
  RectBody = "RectBody",
  RectCorner = "RectCorner",
  Path = "Path",
  PathVertex = "PathVertex",
  Polygon = "Polygon",
  PolygonVertex = "PolygonVertex",
  Annotation = "Annotation",
  Layout = "Layout",
  LayoutAbstract = "LayoutAbstract",
  LayoutImpl = "LayoutImpl",
  LayoutPin = "LayoutPin",
  MetalLayer = "MetalLayer",
  LayoutInstance = "LayoutInstance",
  LayoutRoute = "LayoutRoute",
  LayoutBlockage = "LayoutBlockage",
  SelectionBox = "SelectionBox",
  SelectionBoxCorner = "SelectionBoxCorner",
}
